module.exports = __webpack_public_path__ + "static/media/no-data.3142af34.png";